<template>
  <v-edit-dialog
    v-if="column.editable"
    :return-value.sync="value"
    persistent
    large
    @save="save"
  >
    <v-layout>{{ value }}</v-layout>
    <template v-slot:input>
      <v-text-field :label="column.label" v-model="value"> </v-text-field>
    </template>
  </v-edit-dialog>
  <v-layout v-else>{{ value }}</v-layout>
</template>

<script>
import entities from "../../api/entities";

export default {
  name: "StringColumn",
  props: ["entity_type", "entity", "column", "value"],
  methods: {
    async save() {
      if (this.column.editable) {
        const data = {};
        data[this.column.name] = this.value;
        const result = await entities.update(
          this.token,
          this.entity_type,
          this.entity.id,
          data
        );
        const color = result.success ? "green" : "red";
        this.$root.$emit(
          "notify",
          result.message || "Успешно сохранено",
          color
        );
      }
    }
  }
};
</script>

<style scoped></style>
